import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";

export type BrandAdAccount = {
  id: number;
  account_id: string;
  name: string;
  updated_at: string;
  platform: string;
  brand_id: number;
  created_at: string;
};

export const useBrandAdAccounts = (brandId: number) => {
  return useSWR<BrandAdAccount[]>(`${RelativeUrl}/brands/${brandId}/ad_accounts`, fetcher);
};
